import React from "react";

const HeroEditor = ({
    data,
    update
}) => {

    const competitions = data.competitions || [];

    const updateCompetition = (index, key, value) => {
        const items = competitions.map((item, i) =>
            i === index
                ? { ...item, [key]: value }
                : item
        );

        update("competitions", items);
    };

    const addCompetition = () => {
        update("competitions", [
            ...competitions,
            {
                text: "",
                url: "",
                className: "btn btn-primary",
                breakAfter: false
            }
        ]);
    };

    const removeCompetition = index => {
        update(
            "competitions",
            competitions.filter((_, i) => i !== index)
        );
    };

    return (
        <div className="cms-editor">

            <label>Video URL</label>

            <input
                value={data.videoUrl || ""}
                onChange={e =>
                    update("videoUrl", e.target.value)
                }
            />

            <label>Competition Title</label>

            <input
                value={data.competitionTitle || ""}
                onChange={e =>
                    update(
                        "competitionTitle",
                        e.target.value
                    )
                }
            />

            <h3>Competition Buttons</h3>

            {competitions.map((item, index) => (

                <div
                    className="cms-item"
                    key={index}
                >
                    <strong>
                        Competition {index + 1}
                    </strong>

                    <label>Text</label>

                    <input
                        value={item.text || ""}
                        onChange={e =>
                            updateCompetition(
                                index,
                                "text",
                                e.target.value
                            )
                        }
                    />

                    <label>URL</label>

                    <input
                        value={item.url || ""}
                        onChange={e =>
                            updateCompetition(
                                index,
                                "url",
                                e.target.value
                            )
                        }
                    />

                    <label>Button Class</label>

                    <select
                        value={
                            item.className ||
                            "btn btn-primary"
                        }
                        onChange={e =>
                            updateCompetition(
                                index,
                                "className",
                                e.target.value
                            )
                        }
                    >
                        <option value="btn btn-primary">
                            Primary
                        </option>

                        <option value="btn btn-danger">
                            Danger
                        </option>

                        <option value="btn btn-success">
                            Success
                        </option>
                    </select>

                    <label>
                        <input
                            type="checkbox"
                            checked={
                                item.breakAfter || false
                            }
                            onChange={e =>
                                updateCompetition(
                                    index,
                                    "breakAfter",
                                    e.target.checked
                                )
                            }
                        />

                        {" "}Line break after
                    </label>

                    <button
                        type="button"
                        className="cms-delete"
                        onClick={() =>
                            removeCompetition(index)
                        }
                    >
                        Delete
                    </button>

                </div>

            ))}

            <button
                type="button"
                className="cms-add"
                onClick={addCompetition}
            >
                + Add Competition
            </button>

        </div>
    );
};

export default HeroEditor;